/* eslint-disable react-hooks/exhaustive-deps */
import { QueryRequestHelper } from "@_common/query-request-helper";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue } from "@utils/lodash";
import MenuAuditSvgComponent from "../../../assets/svg-components/left-menu/menuadit";
import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import { toast } from "react-toastify";
import { countKeysWithValues } from "@_common/text-helpers";
import AuditStatusFilter from "./AuditFilter";
import {
  downloadAuditStatus,
  getDataAuditStatusList,
} from "@services/audit.service";
import ScrollableReactTable from "@components/ScrollableDatatable";
import ManageAuditNotfound from "@components/Page-Not-Found/manage-audit-not-found";
import { tableScoreColors } from "@_common/colors";
import FooterWrapper from "@components/common/FooterWrapper";
import "./AuditStatus.scss";
import moment from "moment";
import NoAccessPage from "@components/common/NoAccess";
import { convertCurrentDate } from "@_common/date-helpers";
import Loader from "@components/common/Loader";

const AuditStatus: React.FunctionComponent = (props: any) => {
  const navigate = useNavigate();
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [search_text, setSearchInput] = useState<any>("");
  const [showSearchTextbox, setShowSearchTextbox] = useState<boolean>(false);
  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [limit, setLimit] = useState<number>(100);
  const [page_no, setPage_no] = useState<number>(1);
  const [list, setList] = useState<[]>([]);
  const [isInitialized, setIsInitialized] = useState<boolean>(false);
  const [date, setDate] = useState<Date | null>(() => {
    if (params.date) {
      return new Date(params.date);
    } else {
      const current = new Date();
      current.setMonth(current.getMonth() - 2);
      current.setDate(1);
      return current;
    }
  });

  const pageNo = parseInt(params.page_no || "1");
  const pageSize = parseInt(params.limit || "100");

  useEffect(() => {
    if (props.permissionAPITriggered && !isInitialized) {
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (!params.date && date) {
        const defaultDate = moment(date).format("YYYY-MM-DD");
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set("date", defaultDate);
        navigate(`${window.location.pathname}?${searchParams.toString()}`, {
          replace: true,
        });
      }
      if (params.view_type) {
        handleNavigateDashboard(params.view_type);
      }
      setIsInitialized(true);
      getData();
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
    }
  }, [params.page_no, params.limit]);

  useEffect(() => {
    if (props.permissionAPITriggered && date && isInitialized) {
      getData();
    }
  }, [
    params.date,
    params.search_text,
    params.region_id,
    params.group_id,
    params.location_id,
    params.city_id,
    params.vendor_id,
    params.audit_status,
    params.page_no,
    params.limit,
  ]);

  const getData = useCallback(async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const currentParams = Object.fromEntries(urlSearchParams.entries());
    const currentDate = date || new Date();
    const payload: any = {
      month: currentParams.date
        ? currentParams.date.split("-")[1]
        : moment(currentDate).format("MM"),
      year: currentParams.date
        ? currentParams.date.split("-")[0]
        : moment(currentDate).format("YYYY"),
      search_text: currentParams.search_text || undefined,
      region_id: currentParams.region_id || undefined,
      group_id: currentParams.group_id || undefined,
      location_id: currentParams.location_id || undefined,
      city_id: currentParams.city_id || undefined,
      vendor_id: currentParams.vendor_id || undefined,
      audit_status: currentParams.audit_status || undefined,
      page_no: currentParams.page_no
        ? parseInt(currentParams.page_no)
        : page_no,
      page_size: currentParams.limit ? parseInt(currentParams.limit) : limit,
    };
    Object.keys(payload).forEach((key) => {
      if (payload[key] === undefined) {
        delete payload[key];
      }
    });
    const queryRequest = QueryRequestHelper(payload);
    setIsLoading(true);
    try {
      const resp = await getDataAuditStatusList(queryRequest);
      if (resp?.statusCode === 200) {
        const transformedData = resp.data.locations?.map((item: any) => ({
          ...item,
          site_name: `${getValue(item, "group_name", "")} - ${getValue(
            item,
            "location_name",
            "",
          )}`.trim(),
          is_audit_completed:
            item.is_audit_completed === true ? "Completed" : "WIP",
        }));
        setList(transformedData);
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
      }
    } catch (error) {
      console.error("Error fetching audit status list:", error);
    } finally {
      setIsLoading(false);
    }
  }, [date]);

  const handleNavigateDashboard = useCallback(
    (value: string) => {
      delete params.region_id;
      delete params.group_id;
      delete params.location_id;
      delete params.vendor_id;
      const payload: any = {
        ...params,
        view_type: value,
      };
      if (value) {
        const queryRequest = QueryRequestHelper(payload);
        navigate(`${window.location.pathname}?${queryRequest}`);
      } else {
        delete params.view_type;
        const queryRequest = QueryRequestHelper(payload);
        navigate(`${window.location.pathname}?${queryRequest}`);
      }
    },
    [navigate],
  );

  const handleSubmitDate = useCallback(
    (newDate: any) => {
      const selectedDate = moment(newDate).format("YYYY-MM-DD");
      if (selectedDate && selectedDate !== "Invalid date") {
        setDate(newDate);
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set("date", selectedDate);
        navigate(`${window.location.pathname}?${searchParams.toString()}`, {
          replace: true,
        });
      } else {
        toast.error("Please select a valid date");
      }
    },
    [navigate],
  );

  const toggleSearch = useCallback(() => {
    setShowSearchTextbox((prevState) => !prevState);
  }, []);

  const toggleSearchClose = useCallback(() => {
    setSearchInput("");
    setShowSearchTextbox(false);
    if (params.search_text) {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.delete("search_text");
      navigate(`${window.location.pathname}?${searchParams.toString()}`, {
        replace: true,
      });
    }
  }, [params.search_text, navigate]);

  const handleChangeSearch = useCallback(
    (e: any) => {
      const searchValue = e.target.value;
      setSearchInput(searchValue);
      const searchParams = new URLSearchParams(window.location.search);
      if (searchValue) {
        searchParams.set("search_text", searchValue);
        searchParams.set("page_no", "1");
      } else {
        searchParams.delete("search_text");
      }
      navigate(`${window.location.pathname}?${searchParams.toString()}`, {
        replace: true,
      });
    },
    [navigate],
  );

  const getTableState = useCallback(
    (value: object) => {
      const selectedIndexList = Object.keys(
        getValue(value, "selectedRowIds", {}),
      ).map((item) => parseInt(item));
      const selectedIds =
        list.length > 0
          ? list.filter((_item: object, index: number) =>
            selectedIndexList.includes(index),
          )
          : [];

      if (selectedIds.length > 0) {
        setSelectedIDs(
          selectedIds.map((item: object) => getValue(item, "id", "")),
        );
      } else {
        setSelectedIDs([]);
      }
    },
    [list],
  );

  const handleNavigateLogsYearHistory = useCallback(() => {
    navigate("/self-compliance-logs/VENDOR_AUDIT_SCORE_CARD");
  }, [navigate]);

  const rowClick = useCallback(() => { }, []);

  const getTrProps = useCallback((rowInfo: any) => {
    if (getValue(rowInfo, "id", "")) {
      return {
        style: {},
      };
    }
    return {};
  }, []);

  const handleChangePagination = useCallback(
    (newPageNo: string) => {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set("page_no", newPageNo);
      navigate(`${window.location.pathname}?${searchParams.toString()}`, {
        replace: true,
      });
    },
    [navigate],
  );

  const handleChangeLimit = useCallback(
    (newLimit: string) => {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set("limit", newLimit);
      searchParams.set("page_no", "1");
      navigate(`${window.location.pathname}?${searchParams.toString()}`, {
        replace: true,
      });
    },
    [navigate],
  );

  const handleDownloadAuditStatus = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
    const payload: any = {
      month: params.date
        ? parseInt(params.date.split("-")[1])
        : date
          ? parseInt(moment(date).format("MM"))
          : parseInt(moment(dates).format("MM")),
      year: params.date
        ? params.date.split("-")[0]
        : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
      search_text: params.search_text,
      region_id: params.region_id,
      group_id: params.group_id,
      location_id: params.location_id,
      city_id: params.city_id,
      vendor_id: params.vendor_id,
      audit_status: params.audit_status,
      report_type: "AUDIT_STATUS",
      report_name: `AUDIT_STATUS - ${convertCurrentDate(
        from_date,
      )} to ${convertCurrentDate(to_date)}`,
    };

    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    setIsLoading(true);
    try {
      let resp = await downloadAuditStatus(payload);
      if (resp) {
        setIsLoading(false);
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/AUDIT_STATUS`);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  function getRectNcRatio(data: any): string | null {
    const cycle = Number(data?.cycle_max2);
    if (!cycle || cycle < 2) return null;
    const currentKey = `rect_nc_count_${cycle}`;
    const previousKey = `rect_nc_count_${cycle - 1}`;
    const currentValue = Number(data?.[currentKey] ?? 0);
    const previousValue = Number(data?.[previousKey] ?? 0);
    return `${currentValue}/${previousValue}`;
  }

  const selectedParms =
    params.vendor_id ||
    params.location_id ||
    params.group_id ||
    params.audit_status ||
    params.region_id ||
    params.search_text ||
    "";
  const columns = React.useMemo(
    () => [
      {
        Header: () => (
          <div className="">
            <div>Site Name</div>
            <div>Vendor Name</div>
            <div className="text-gray-666">Window Status</div>
            <div className="">Rect. Status</div>
          </div>
        ),
        accessor: "site_name",
        width: 250,
        Cell: ({ row }: any) => {
          const handleNavigate = () => {
            const selectedDate =
              params.date || moment(date).format("YYYY-MM-DD");
            const rowData = encodeURIComponent(
              JSON.stringify({
                site_name: row.original.site_name,
                vendor_name: row.original.vendor_name,
                region_name: row.original.region_name,
                location_name: row.original.location_name,
                group_name: row.original.group_name,
                submission_date: row.original.submission_date,
                iterim_date: row.original.iterim_date,
                final_date: row.original.final_date,
                uploaded_count: row.original.uploaded_count,
                is_audit_completed: row.original.is_audit_completed,
                critical_score: row.original.critical_score,
                full_score: row.original.full_score,
                headcount: row.original.headcount,
                location_id: row.original.location_id,
                vendor_id: row.original.vendor_id,
                audit_status: row.original.audit_status,
              }),
            );

            navigate(
              `/audit/audit-status/task/list/${row.original.location_id}?date=${selectedDate}&vendor_id=${row.original.vendor_id}&rowData=${rowData}&selectedParms=${selectedParms}`,
            );
          };

          return (
            <div className="d-flex flex-column gap-1">
              <div
                className="cursor-pointer fw-bold text-primary"
                onClick={handleNavigate}
              >
                {row.original.site_name}{" "}
                {!row.original.location_is_active && (
                  <span className="text-danger ms-1">(Inactive)</span>
                )}
              </div>

              <div className="cursor-pointer fw-bold" onClick={handleNavigate}>
                {row.original.vendor_name}
                {!row.original.vendor_is_active && (
                  <span className="text-danger ms-1">(Inactive)</span>
                )}
              </div>

              <div
                className={`small fw-semibold ${row.original.rect_status === "RECTIFICATION_WINDOW_OPEN"
                  ? "text-success"
                  : row.original.rect_status === "RECTIFICATION_WINDOW_CLOSED"
                    ? "text-danger"
                    : "text-muted"
                  }`}
              >
                {row.original.rect_status || "-"}
              </div>
              {row.original.cycle_max2 > 1 && (
                <div className="fw-semibold text-primary">
                  {getRectNcRatio(row.original) || "-"}
                </div>
              )}
            </div>
          );
        },
      },
      {
        Header: () => (
          <div>
            <div>Region</div>
            <div>Site</div>
            <div>Account</div>
            <div>City</div>

          </div>
        ),
        accessor: "region_name",
        width: 250,
        Cell: ({ row }: any) => (
          <div>
            <div>{row.original.region_name}</div>
            <div>{row.original.site_name}</div>
            <div>{row.original.group_name}</div>
            <div>{row.original.city_name}</div>

          </div>
        ),
      },
      {
        Header: () => (
          <div>
            <div>Submission Date</div>
            <div>Interim Date</div>
            <div>Final Date</div>
          </div>
        ),
        accessor: "submission_date",
        width: 250,
        Cell: ({ row }: any) => (
          <div>
            <div>{row.original.submission_date || "-"}</div>
            <div>{row.original.iterim_date || "-"}</div>
            <div>{row.original.final_date || "-"}</div>
          </div>
        ),
      },
      {
        Header: "Audit Status",
        accessor: "audit_status",
        width: 150,
        Cell: ({ row }: any) => {
          const value = getValue(row, `values.audit_status`, "")?.toLowerCase();
          let backgroundColor = "";
          let textColor = "#000";
          switch (value) {
            case "submitted":
              backgroundColor = "#47BD65";
              textColor = "#fff";
              break;
            case "pending_audit":
              backgroundColor = "#FFA010";
              textColor = "#fff";
              break;
            case "not_submitted":
              backgroundColor = "#D9D9D9";
              textColor = "#fff";
              break;
            case "absent":
              backgroundColor = "#FF826F";
              textColor = "#fff";
              break;
            default:
              backgroundColor = "#f0f0f0";
              textColor = "#000";
          }
          return (
            <div
              className="score-chip text-center fw-medium rounded"
              style={{ backgroundColor, color: textColor }}
            >
              {value ? value.charAt(0).toUpperCase() + value.slice(1) : "-"}
            </div>
          );
        },
      },
      {
        Header: "Critical Score",
        accessor: "critical_score",
        width: 200,
        Cell: ({ row }: any) => {
          const value = getValue(row, `values.critical_score`, null);
          return (
            <div
              className="score-button"
              style={{
                backgroundColor: tableScoreColors(
                  value ? parseFloat(value) : 0,
                ),
              }}
            >
              {value === null ? "- -" : `${value}%`}
            </div>
          );
        },
      },
      {
        Header: "Full Score",
        accessor: "full_score",
        width: 150,
        Cell: ({ row }: any) => {
          const value = getValue(row, `values.full_score`, null);
          return (
            <div
              className="score-button"
              style={{
                backgroundColor: tableScoreColors(
                  value ? parseFloat(value) : 0,
                ),
              }}
            >
              {value === null ? "- -" : `${value}%`}
            </div>
          );
        },
      },
      { Header: "Head Count", accessor: "headcount", width: 150 },
    ],
    [date, params.date, navigate, selectedParms],
  );
  return (
    <DashboardLayout
      permissions={getValue(props, "tabPermissionList", [])}
      subTabPermissionList={getValue(props, "subTabPermissionList", [])}
    >
      {!isLoading &&
        !getValue(props, `subTabPermissionList`, []).includes(
          "audit_audit_status",
        ) ? (
        <NoAccessPage />
      ) : (
        <>
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <MenuAuditSvgComponent />
              </div>
              <div className="title-wrapper me-2">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Audit
                </h6>
                <h4 className="dashbaord-wrapper__header-title">Status</h4>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <RightMenuHeaders
                monthYear={!["SITE_MIS"].includes(params.view_type)}
                value={date}
                onChange={handleSubmitDate}
                handleSubmitDate={handleSubmitDate}
                isSearch={true}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                smartFilter={false}
                lineSeperator={true}
                selectedFilterCount={countKeysWithValues(params)}
                downloadSelfComplianceReport={true}
                handleDownloadSelfComplianceReport={handleDownloadAuditStatus}
                downloadLoading={isLoading}
                handleNavigateLogs={handleNavigateLogsYearHistory}
                isApplyButtonRequied={false}
              />
            </div>
          </div>

          <div
            className="main-page-layout-wrapper"
            id={
              getValue(selectedIDs, "length", 0) > 0
                ? "blueNavigationVisible"
                : ""
            }
          >
            <div className="admin-wrapper position-relative">
              <AuditStatusFilter
                date={date}
                onFilterChange={getData}
                TotalListCount={list}
                isAuditStatus={true}
              />
            </div>
            <div>
              {isLoading || !props.permissionAPITriggered ? (
                <Loader />
              ) : list && list.length > 0 ? (
                <ScrollableReactTable
                  columns={columns}
                  data={list}
                  getTableState={getTableState}
                  rowClick={rowClick}
                  checkboxlogo
                  check={false}
                  selectedIDs={selectedIDs}
                  getTrProps={getTrProps}
                />
              ) : (
                <>
                  {Object.keys(params).length !== 0 ? (
                    <>
                      <ManageAuditNotfound />
                    </>
                  ) : (
                    <>
                      <ManageAuditNotfound />
                    </>
                  )}
                </>
              )}
            </div>
            <FooterWrapper
              list={list}
              totalCount={totalCount}
              limit={pageSize}
              page_no={pageNo}
              handleChangePagination={handleChangePagination}
              handleChangeLimit={handleChangeLimit}
              hideCount
            />
          </div>
        </>
      )}
    </DashboardLayout>
  );
};

export default AuditStatus;
